import Http from '@/common/http'
export default class Track {
  static group (param = {}) {
    return Http.post('/setting/track/group', param)
  }
  static doGroupSubmit (param = {}) {
    return Http.post('/setting/track/doGroupSubmit', param)
  }
  static event (param = {}) {
    return Http.post('/setting/track/event', param)
  }
  static doEventSubmit (param = {}) {
    return Http.post('/setting/track/doEventSubmit', param)
  }
  static link (param = {}) {
    return Http.post('/setting/track/link', param)
  }
  static doLinkSubmit (param = {}) {
    return Http.post('/setting/track/doLinkSubmit', param)
  }
  static getTagList (param = {}) {
    return Http.post('/setting/track/getTagList', param)
  }
  static getTypeList (param = {}) {
    return Http.post('/setting/track/getTypeList', param)
  }
  static getSorturlList (param = {}) {
    return Http.get('/setting/track/getSorturlList', param)
  }
  static saveSortUrl (param = {}) {
    return Http.post('/setting/track/saveSortUrl', param)
  }
}
